<template>
    <div>
        <div class="">
            <div class="d-flex align-items-center">
                <label for="size" class="form-label mt-0 me-2 mb-0 flex-shrink-0">Velikost okruhu:</label>
                <input type="number" class="form-control mt-1 me-1 w-25 py-1" min="0.1" max="1000" id="size"
                    v-model="size" style="border-radius: 55px;">
                <span class="form-label mb-0">km</span>
            </div>
            <div class="range-container w-100">
                <input type="range" class="form-range" min="0.1" max="1000" id="size" v-model="size">
            </div>
        </div>
        <div class="mt-2" id="map3">
            <CompanyLocationSearchMap ref="companyMap" @Area="updateArea"
                :clearArea="clearArea" :size="size" />
        </div>
    </div>
</template>
<script>
import CompanyLocationSearchMap from '@/components/CompanyLocationSearchMap.vue';

export default {
    components: {
        CompanyLocationSearchMap,
    },
    props: {
        clearArea: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            size: 0.1
        }
    },
    watch: {
        clearArea(newValue) {
            if (newValue === true) {
                console.log('clearArea', newValue)
                this.size = 100
                this.$emit('AreaCleared', null);
            }
        }
    },
    mounted() {
        const modalEl = document.getElementById('addressModal');
        if (modalEl) {
            modalEl.addEventListener('shown.bs.modal', () => {
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.companyMap?.map) {
                            this.$refs.companyMap.map.invalidateSize();
                            this.$refs.companyMap.map.setView([49.8175, 15.4730], 6); // set view to the Czech Republic
                        }
                    }, 300);
                });
            });
        }
    },
    methods: {
        updateArea(Area) {
            this.$emit('Area', Area);
        },
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

#map3 {
    height: 250px;
    width: 100%;
    border-radius: 35px;
}

.form-label {
    color: $white;
}

/* Style the container for better positioning (optional) */
.range-container {
    width: 300px;
    margin: 10px auto 20px auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Remove default appearance for the range slider */
input[type="range"] {
    --webkit-appearance: none;
    /* For Chrome/Safari */
    width: 100%;
    height: 8px;
    background: #ddd;
    border-radius: 5px;
    outline: none;
    opacity: 0.9;
    transition: 0.3s ease-in-out;
}

/* Change background on hover */
input[type="range"]:hover {
    background: #ccc;
}

/* Style the thumb (the draggable handle) */
input[type="range"]::-webkit-slider-thumb {
    --webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: $purple;
    /* Change to your desired color */
    border: 2px solid #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: 0.3s ease-in-out, transform 0.2s ease;
}

/* Thumb interaction feedback */
input[type="range"]::-webkit-slider-thumb:active {
    transform: scale(1.2);
    background: $purple;
}

/* For Firefox */
input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: $purple;
    border: 2px solid #fff;
    cursor: pointer;
}

/* For IE */
input[type="range"]::-ms-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: $purple;
    border: 2px solid #fff;
    cursor: pointer;
}

/* Style the progress bar (track below the thumb) */
input[type="range"]::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 5px;
    background: linear-gradient(to left, $purple 0%, #ddd 100%);
}

/* For Firefox track */
input[type="range"]::-moz-range-track {
    height: 8px;
    border-radius: 5px;
    background: linear-gradient(to right, $purple 0%, #ddd 100%);
}

/* For IE track */
input[type="range"]::-ms-track {
    height: 8px;
    border-radius: 5px;
    background: linear-gradient(to right, $purple 0%, #ddd 100%);
}
</style>